/**
 * Image Logger
 * =================================
 *
 * Logs the image related information, warning or errors.
 *
 */

import { logger } from './logger';

const productIdAttribute = 'data-product-id';

function logImageLoadError (img) {
    const productId = img.getAttribute(productIdAttribute);

    // We are logging only for lazy loading in menu page related images.
    // If required, we can extend this to other images later.
    if (productId) {
        logger.error(`Image failed to load: ${img.src}. Menu Page: ${window.location.href}. Product Id: ${productId}.`);
    }
}

export {
    logImageLoadError
};
